/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./federatedLogin.vue?vue&type=template&id=a92a514c&scoped=true"
import script from "./federatedLogin.vue?vue&type=script&lang=js"
export * from "./federatedLogin.vue?vue&type=script&lang=js"
import style0 from "./federatedLogin.vue?vue&type=style&index=0&id=a92a514c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92a514c",
  null
  
)

export default component.exports